import api from 'api';
import { Modal, ModalHeader, ModalBody } from 'components/modal';
import { Dispatch, SetStateAction, useState } from 'react';
import { ClientType, RootState } from 'types';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Form from 'components/form/form';
import { toast } from 'react-toastify';
import { ContactUsRequestFP } from 'api/focal-points';
import './fp-query-modal.scss'

function FPQueryModal({
    open,
    setOpen
} : {
    open: boolean,
    setOpen: Dispatch<SetStateAction<boolean>>,
}) {
    const params: any = useParams();
    const state = useSelector((state: RootState) => state);
    const [client] = useState<ClientType | undefined>(state.clients.find(x => x.Id === params.clientId));

    function onSubmit(data: ContactUsRequestFP) { 
        api.focalPoints.contactUs(data)
        .then((data: { Success: boolean; Message: string; }) => {
            if (data.Success) {
                toast.success(data.Message); 
                setOpen(false);
                return;
            } else {
                toast.error(data.Message);
                return; 
            }
        }).catch(err => {
            toast.error(err.toString());
        })
    }

    return (
        <Modal id="fp-query-modal" open={open} setOpen={setOpen}>
            <ModalHeader>
                    <h2>{'Contact Focal Points'}</h2>
            </ModalHeader>
            <ModalBody>
                <Form id={'fp-query-form'} formName={''} formInputs={[
                    {Type: "text", Name:"Fullname", Placeholder:"Full Name", Value:state.user ? state.user.Name + " " + state.user.Surname : "", Required: true},
                    {Type: "text", Name:"CompanyName", Placeholder:"Company", Value:client ? client?.Name : "", Required: true},
                    {Type: "email", Name:"EmailAddress", Placeholder:"email@provider.com", Value:state.user ? state.user.Email : "", Required: true},
                    {Type: "text", Name:"ContactNumber", Placeholder:"+27 --- ----", Required: true},
                    {Type: "text", Name:"How", Placeholder:"How did you find out about us?", Value:"amaSocial Referral", Required: true},
                    {Type: "text", Name:"Subject", Placeholder:"Subject", Value:`Narrative Analysis: ${state.project ? state.project.Description : ""}`, Required: true},
                    {Type: "text", Name:"Message", Placeholder:"Hi, \nI would like to enquire about Narrative Analysis...", Required: true, Rows:5},
                    ]} onSubmit={onSubmit} />
            </ModalBody>
        </Modal>
    )
}

export default FPQueryModal;
